import React, {useEffect, useState} from 'react'
import {connect} from 'dva'
import styles from "./index.module.less"
import {Button, Result} from "antd"
import {routerRedux} from 'dva/router'
import QRCode from "qrcode"

const namespace = 'ticketorder'

const Component = ({
                     model,
                     loading,
                     location,
                     dispatch,
                     app,
                   }) => {

  const {orderInfo: {status, ticketCode}} = model
  const isLoading = loading.effects[`${namespace}/init`]
  const [ticketCodeImage, setTicketCodeImage] = useState('')

  useEffect(() => {
    ticketCode && QRCode.toDataURL(ticketCode, {margin: 2, scale: 8}).then(setTicketCodeImage)
  }, [ticketCode])

  const handleBack = () => {
    dispatch(routerRedux.replace({
      pathname: `/ticket`,
    }))
  }

  return (
    <div className={styles['page-order']}>
      {isLoading && <div style={{fontSize: 18}}>正在获取订单信息，请稍候...</div>}
      {
        status === 2 && <Result
          status="success"
          title="你已购票完成"
          subTitle="请保存您的门票二维码！"
          extra={[
            <div><img src={ticketCodeImage} style={{width: 200}}/></div>,
            <Button type="default" key="console" onClick={handleBack}>
              返回
            </Button>
          ]}
        />
      }
      {
        status === 1 && <Result
          status="success"
          title="正在出票"
          subTitle="请耐心等待"
          extra={[
            <Button type="default" key="console" onClick={handleBack}>
              返回
            </Button>
          ]}
        />
      }
    </div>
  )
}

export default connect(({ticketorder, app, loading}) => ({
  loading,
  model: ticketorder,
  app,
}))(Component)
